const DOMAIN = "https://seekho.in";

export const RouteName = {
  index: DOMAIN,
  app: `${DOMAIN}/app`,
  premium: `${DOMAIN}/premium`,
  series: `${DOMAIN}/series`,
  video: `${DOMAIN}/video`,
  category: `${DOMAIN}/category`,
  privacyPolicy: `${DOMAIN}/privacy-policy`,
  cancellationPolicy: `${DOMAIN}/cancellation-policy`,
  termsAndCondition: `${DOMAIN}/terms-and-conditions`,
  team: `${DOMAIN}/team`,
  faq: `${DOMAIN}/faqs`,
  blogs: `${DOMAIN}/blog`,
  contactUs: `${DOMAIN}/contact-us`,
  details: `${DOMAIN}/details`,
};

export const routeToDomain =
  process?.env?.NODE_ENV === "development"
    ? ""
    : process?.env?.NEXT_PUBLIC_ENVIRONMENT === "production"
    ? "https://seekho.in"
    : process?.env?.NEXT_PUBLIC_ENVIRONMENT === "staging"
    ? "https://staging.seekho.in"
    : "";
